import React, { useEffect, useState } from 'react'
import { IconTimelineApproved, IconTimelineClock, IconTimelineMail, IconTimelinePending, IconTimelineRecipient, IconTimelineRejected } from '../iconSet/IconSet'
import { TimelineElementPropsType } from '../earlyWarning/emailComp/EmailTypes';
import { APICallGetUserInfoRequest, APIGetUserDetailsTypes, APIResponseHistoryRecipientType } from '../../services/APIEarlyWarningService';
import { formatTimestamp } from './WarningWorkflowProcess';

const warningTypeMap: Record<string, string> = {
    LSW: "landslide warning",
    HRW: "heavy rain warning",
    LIG: "severer lightning warning",
    MWA: "marine weather warning",
    NTW: "nuclear threat warning",
    ASW: "air strike warning",
    HWN: "high wind warning",
    FLW: "flood warning",
    TW: "Tsunami warning",
    CUS: "Custom warning",
    GUS: "Gust wind warning"
};

type TimelineRecipientElementPropsType = {
    data: APIResponseHistoryRecipientType;
    warningCatId: string;
    performedBy: string;
    warningNumber: string;
    warningName: string;
    performedData: string;
    index: number;
    length: number;
}

const TimelineRecipientElement = (props: TimelineRecipientElementPropsType) => {

    console.log("TIMELINE: ", props.warningCatId)
    return (
        <>
            <div className='left'>
                {props.index === 0 && (
                    <span className='res-list-tag' style={{fontSize: "0.7rem", whiteSpace: 'nowrap'}}>Recipient list</span>
                )}
                {props.data.status === 'RECIPIENT' && (
                    <div className='icon-bg' style={{backgroundColor: 'var(--color-main-red)'}}>
                        <IconTimelineRecipient width='1.5rem' color='var(--color-main-white)'/>
                    </div>
                )}
                {props.data.status === 'ACKNOWLEDGE_PENDING' && (
                    <div className='icon-bg' style={{backgroundColor: 'var(--color-button-green-bg)'}}>
                        <IconTimelineRecipient width='1.5rem' color='var(--color-main-white)'/>
                    </div>
                )}
                {props.data.status === 'ACKNOWLEDGE' && (
                    <div className='icon-bg' style={{backgroundColor: 'var(--color-main-blue)'}}>
                        <IconTimelineRecipient width='1.5rem' color='var(--color-main-white)'/>
                    </div>
                )}
                {props.index === props.length - 1 && (
                    <span className='res-list-tag' style={{ position: 'absolute', fontSize: "0.7rem", bottom: '0', whiteSpace: 'nowrap'}}>End of recipient list</span>
                )}
            </div>
            <div className='right'>
                {props.index === 0 && (
                    <span style={{height: '2rem'}}></span>
                )}
                <div className='message'>
                    <div className='message-header'>
                        {props.data.status === 'RECIPIENT' && (
                            <div>
                                <span className='post' style={{color: 'var(--color-main-red)', textTransform: 'capitalize'}}>{props.data && props.data.areaList && props.data.areaList.join(', ')}</span>
                                <span className='post' style={{color: 'var(--color-main-red)', textTransform: 'capitalize'}}>({props.data.role} - {props.data.department})</span>
                                <span className='post' style={{color: 'var(--color-text)'}}> as a recipient of {warningTypeMap[props.warningCatId && props.warningCatId]}</span>
                            </div>
                        )}
                        {props.data.status === 'ACKNOWLEDGE' && (
                            <div>
                                <span className='post' style={{color: 'var(--color-main-blue)', textTransform: 'capitalize'}}>{props.data && props.data.areaList && props.data.areaList.join(', ')}</span>
                                <span className='post' style={{color: 'var(--color-main-blue)', textTransform: 'capitalize'}}>({props.data.role} - {props.data.department})</span>
                                <span className='post' style={{color: 'var(--color-text)'}}> as a recipient of {warningTypeMap[props.warningCatId && props.warningCatId]}</span>
                            </div>
                        )}
                        {props.data.status === 'ACKNOWLEDGE_PENDING' && (
                            <div>
                                <span className='post' style={{color: 'var(--color-main-green)', textTransform: 'capitalize'}}>{props.data && props.data.areaList && props.data.areaList.join(', ')}</span>
                                <span className='post' style={{color: 'var(--color-main-green)', textTransform: 'capitalize'}}>({props.data.role} - {props.data.department})</span>
                                <span className='post' style={{color: 'var(--color-text)'}}> waiting as a next recipient {warningTypeMap[props.warningCatId && props.warningCatId]}</span>
                            </div>
                        )}

                        {props.data.status !== 'ACKNOWLEDGE_PENDING' && (
                            <div style={{display: 'flex', alignItems: 'center', gap: '0.5rem'}}>
                                <IconTimelineClock width='1rem' color='var(--color-text)'/>
                                <span style={{fontSize: '0.7rem', color: 'var(--color-text)'}}>{props.data && formatTimestamp(props.data.performedDate)}</span>
                            </div>
                        )}
                        
                    </div>

                    <div>
                        {props.data.status === 'RECIPIENT' && (
                            <div>
                                <div className='body'>
                                    <span className='body-data'>{props.performedBy} has been generated alert notification to the {props.data.firstName} {props.warningName} which under ({props.warningNumber}) on {formatTimestamp(props.performedData)} Awaiting Aknowlagement</span>
                                </div>
                            </div>
                        )}

                        {props.data.status === 'ACKNOWLEDGE' && (
                            <div>
                                <div className='body'>
                                    <span className='body-data'>{props.performedBy} has been generated alert notification to the {props.data.firstName} {props.warningNumber} which under ({props.warningNumber}) on {formatTimestamp(props.performedData)} Acknowledged</span>
                                </div>
                            </div>
                        )}
                        
                    </div>
                    
                    {props.data.status === 'RECIPIENT' && (
                        <div className='tag-container'>
                            {props.data.email && (
                                <div style={{backgroundColor: 'var(--color-main-red)'}}>
                                    <span className='label'>email:</span>
                                    <span className='data'>{props.data.email}</span>
                                </div>
                            )}
                            {props.data.contactNumber && (
                                <div style={{backgroundColor: 'var(--color-main-red)'}}>
                                    <span className='label'>mobile:</span>
                                    <span className='data'>{props.data.contactNumber}</span>
                                </div>
                            )}
                        </div>
                    )}

                    {props.data.status === 'ACKNOWLEDGE' && (
                        <div className='tag-container'>
                            {props.data.email && (
                                <div style={{backgroundColor: 'var(--color-main-blue)'}}>
                                    <span className='label'>email:</span>
                                    <span className='data'>{props.data.email}</span>
                                </div>
                            )}
                            {props.data.contactNumber && (
                                <div style={{backgroundColor: 'var(--color-main-blue)'}}>
                                    <span className='label'>mobile:</span>
                                    <span className='data'>{props.data.contactNumber}</span>
                                </div>
                            )}
                        </div>
                    )}

                    {props.data.status === 'ACKNOWLEDGE_PENDING' && (
                        <div className='tag-container'>
                            {props.data.email && (
                                <div style={{backgroundColor: 'var(--color-main-green)'}}>
                                    <span className='label'>email:</span>
                                    <span className='data'>{props.data.email}</span>
                                </div>
                            )}
                            {props.data.contactNumber && (
                                <div style={{backgroundColor: 'var(--color-main-green)'}}>
                                    <span className='label'>mobile:</span>
                                    <span className='data'>{props.data.contactNumber}</span>
                                </div>
                            )}
                        </div>
                    )}
                    
                </div>
                {props.index === props.length - 1 && (
                    <span style={{height: '2rem'}}></span>
                )}
            </div>
        </>
    )
}

export default TimelineRecipientElement